export const TIMESHEET_LIST="TIMESHEET_LIST";
export const USER_TIMESHEET_LIST="USER_TIMESHEET_LIST";
export const ADDTIMESHEET_DETAILS="ADDTIMESHEET_DETAILS";
export const EDITTIMESHEET_DETAILS="EDITTIMESHEET_DETAILS";
export const CLEAR_TIMESHEET="CLEAR_TIMESHEET";
export const PENDING_TIMESHEET="PENDING_TIMESHEET";
export const APPROVE_TIMESHEET="APPROVE_TIMESHEET";
export const SENDBACK_TIMESHEET="SENDBACK_TIMESHEET";
export const BULK_APPROVE_TIMESHEET="BULK_APPROVE_TIMESHEET";

